import { createAsyncThunk } from "@reduxjs/toolkit";
//import axios from "axios";
//import { API_URL } from "src/utils/apiConfig";
import { apiClient } from '../../helpers/api_helper';
import { unitsUsersError, unitsUsersSuccess } from "./reducer";
import { userId } from "src/helpers/user_id";

export const getUnitsUsers = createAsyncThunk("unity/getUnitsUsers", async () => {
    try {
      const response = await apiClient.get(`/unity/unityusers/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addUnitUsers = createAsyncThunk("unity/addUnitUsers", async (unitsUsers: any, { dispatch }) => {
    try {
      const response = await apiClient.post(`/unity/unityusers/`, {
          user: unitsUsers.user,
          unidade: unitsUsers.unit,
          level: unitsUsers.level,
          create_user: userId,
          update_user: userId,
        }
      );
      dispatch(unitsUsersSuccess(response));
      return response;
    } catch (error) {
      dispatch(unitsUsersError(error));
      return error;
    }
  }
);

export const updateUnitUsers = createAsyncThunk("unity/updateUnitUsers", async (unitsUsers: any) => {
    try {
      const response = await apiClient.put(`/unity/unityusers/${unitsUsers.id}/`,{
          user: unitsUsers.user_id,
          unidade: unitsUsers.unit_id,
          level: unitsUsers.level,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteUnitUsers = createAsyncThunk("unity/deleteUnitUsers", async (unitsUsers: any) => {
    try {
      const response = await apiClient.delete(`/unity/unityusers/${unitsUsers}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);
